import { apiGet, getHostApi, processErrorMessage } from './apiWrapper';
import { SECTIONS } from './reportStore';

const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'; // hardcoded to save 9KB lib link just to get one value
const RELIABILITY_REQUEST = "RELIABILITY_REQUEST";
const RELIABILITY_SUCCESS = "RELIABILITY_SUCCESS";
const RELIABILITY_ERROR = "RELIABILITY_ERROR";
const RELIABILITY_RESET = "RELAIBILITY_RESET";

export const RELIABILITY_SECTIONS = {
    reliability: SECTIONS.reliabilityReport,
    cee: SECTIONS.reliabilityCEE,
    aml: SECTIONS.reliabilityAML
}

const initialState = {
    isRequested: false,
    error: null
};

export const reliabilityActions = {
    requestCeeAmlData: (entityId, action) => async (dispatch, getState) => _requestCeeAmlData(entityId, action, dispatch, getState),
    resetCeeAmlData: () => async (dispatch) => dispatch({ type: RELIABILITY_RESET })
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case LOCATION_CHANGE:
            return { ...state, location: action.payload.pathname };
        case RELIABILITY_REQUEST:
            return { ...state, isRequested: true }
        case RELIABILITY_SUCCESS:
            return { ...state, isRequested: false }
        case RELIABILITY_ERROR:
            return { ...state, isRequested: false, error: action.error }
        case RELIABILITY_RESET:
            return initialState;
        default:
            return state;
    };
};

function _requestCeeAmlData(entityId, action,dispatch, getState) {
    if (getState().reliability.isRequested)
        return;

    dispatch({ type: RELIABILITY_REQUEST });
    apiGet(
        `${getHostApi()}/api/report/${entityId}/reliability-request`,
        {},
        (s) => {
            dispatch({ type: RELIABILITY_SUCCESS, error: null });
            action();
        },
        (e) => {
            dispatch({ type: RELIABILITY_ERROR, error: processErrorMessage(e, "UnhappyUser.SectionError") });
        }
    )
}
